module.exports = new __parcel__URL__("damagereductionbuff.d46757d8.png").toString();